var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{staticClass:"line",attrs:{"fill":"currentColor","d":"M16,7.22,15.71,7A6.91,6.91,0,0,0,6.79,8.45h0a7.48,7.48,0,0,0,.49,10.23L16,27l8.72-8.32a7.48,7.48,0,0,0,.49-10.23h0A6.91,6.91,0,0,0,16.29,7Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }